import React, { useState } from 'react';
import CancelLogin from './CancelLogin'; // Adjust the import path as needed
import { initialiseConsent } from '../actions';
import { postMessageSuccess } from '../helpers/postMessage';

/*function RevocationInfo({ revocationInfo }) {
  return (
    <p>
      {revocationInfo.text}{' '}
      <a href={process.env.REACT_APP_BANKSTATEMENTS_URL + '/' + revocationInfo.link.href} target={revocationInfo.link.target} rel="noopener noreferrer">
        {revocationInfo.link.label}
      </a>
    </p>
  );
}*/


const Consent = (props) => {
    const [openSections, setOpenSections] = useState({});

    const consentData = JSON.parse(props.consentData);

    const toggleSection = (key) => {
        setOpenSections((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const onCancel = () => {
        const slug = props.slug;
        props.dispatch(postMessageSuccess("data-consent-illion", {data: slug}, "cancelled"));
        props.dispatch({ type: 'LOGIN_PROCESS_CANCELLED' });
    }

    const onSubmit = (e) => {
        e.preventDefault();
        const slug = props.slug;
        props.dispatch(postMessageSuccess("data-consent-illion", {data: slug}));
        props.dispatch(initialiseConsent(slug))
    };

    let backToSelectionBtnText = props.theme.text.backToSelectionBtn;
    let requireWinz = false;
    

    return (
        <div className="step-content">
            <div id="intro">
                <div className="consent-data-wrapper">
                    <div className="formMain">
                        <h2>{consentData.title}</h2>
                        <p>{consentData.description}</p>

                        {consentData.sections.map((section, sectionIndex) => (
                            <div className="consent-type-section" key={sectionIndex}>
                                <h3>{section.title}</h3>
                                {section.subSections.map((sub, subIndex) => {
                                    const key = `${sectionIndex}-${subIndex}`;
                                    return (
                                        <div className="section" key={key}>
                                            <button
                                                className="toggle-btn"
                                                onClick={() => toggleSection(key)}
                                            >
                                                <span>{sub.title}</span>
                                                <span className={`arrow ${openSections[key] ? 'rotate' : ''}`}>
                                                    ▶
                                                </span>
                                            </button>
                                            {openSections[key] && (
                                                <div className="toggle-content">
                                                    <p>{sub.description}</p>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        ))}

                        <p dangerouslySetInnerHTML={{ __html: consentData.accessExpiry }}></p>

                        {/*<RevocationInfo revocationInfo={consentData.revocationInfo} />*/}
                        <hr />
                        <p><strong>{consentData.finalConsentPrompt}</strong></p>
                        <p>{consentData.acceptanceNote}</p>
                    </div>

                    <div className="form-group">
                        <button
                            type="submit"
                            title="I Consent"
                            className="form-control btn btn-primary"
                            onClick={onSubmit}
                        >
                            I Consent
                        </button>
                    </div>
                    <CancelLogin
                        action={onCancel}
                        theme={props.theme}
                        backToSelectionBtnText={backToSelectionBtnText}
                        requireWinz={requireWinz}
                    />
                </div>
            </div>
        </div>
    );
};

export default Consent;
